import React, { PropTypes } from 'react'

import './AliadaProfileSkills.scss'
import LabeledIcon from 'components/LabeledIcon'

const AliadaProfileSkills = (props) => {
  const {
    aliada,
    label,
    skills,
    preferences
  } = props

  const slugIcons = {
    cleaning: 'cleaning',
    cooking: 'cook',
    pets: 'pet',
    laundry: 'laundry',
    ironing: 'ironing'
  }

  const skippedPreferences = [
    'offices'
  ]

  return (
    <div className='AliadaProfileSkills'>
      { label && (<p className='AliadaProfileSkills-label'>{label}</p>) }
      <div className='AliadaProfileSkills-icons'>
        <ul>
          {skills && aliada.skills.map((skill) => (
            <li key={skill.slug}>
              <LabeledIcon iconType='icon' iconContent={slugIcons[skill.slug]} label={skill.name} />
            </li>
          ))}

          {preferences && aliada.preferences.map((preference) => {
            const skip = skippedPreferences.includes(preference.slug)

            if (skip) {
              return null
            } else {
              return (
                <li key={preference.slug}>
                  <LabeledIcon iconType='icon' iconContent={slugIcons[preference.slug]} label={preference.name} />
                </li>
              )
            }
          })}
        </ul>
      </div>
    </div>
  )
}

AliadaProfileSkills.displayName = 'AliadaProfileSkills'
AliadaProfileSkills.propTypes = {
  aliada: PropTypes.shape({
    skills: PropTypes.arrayOf(PropTypes.shape({
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })).isRequired,
    preferences: PropTypes.arrayOf(PropTypes.shape({
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })).isRequired
  }).isRequired,
  label: PropTypes.string,
  skills: PropTypes.bool,
  preferences: PropTypes.bool
}
AliadaProfileSkills.defaultProps = {
  skills: true,
  preferences: false
}

export default AliadaProfileSkills



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/AliadaProfileSkills/AliadaProfileSkills.js